export default "__VITE_ASSET__BmCd30Je__"